import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2, BookOpen, Utensils, Sparkles, RefreshCw, Moon } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <BookOpen className="text-terracotta" size={28} strokeWidth={1.5} data-id="element-111" />,
    title: 'La Guía Maestra "Hogar en Autopiloto"',
    desc: '(PDF 55+ páginas)'
  }, {
    icon: <Utensils className="text-terracotta" size={28} strokeWidth={1.5} data-id="element-112" />,
    title: 'El Manual de la Despensa SOS',
    desc: 'Cómo cenar real en 15 min sin descongelar nada.'
  }, {
    icon: <Sparkles className="text-terracotta" size={28} strokeWidth={1.5} data-id="element-113" />,
    title: 'El Protocolo de "Piel Limpia"',
    desc: 'El secreto visual para que tu casa parezca de hotel con el mínimo esfuerzo.'
  }, {
    icon: <RefreshCw className="text-terracotta" size={28} strokeWidth={1.5} data-id="element-114" />,
    title: 'Sistema de Sincronización Total',
    desc: 'Cómo terminar de cenar con la cocina ya recogida.'
  }, {
    icon: <Moon className="text-terracotta" size={28} strokeWidth={1.5} data-id="element-115" />,
    title: 'Checklist de "Cierre de Tienda"',
    desc: '5 minutos para despertar en una casa que te sonríe.'
  }];
  return <section className="py-24 bg-linen" data-id="element-116">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-117">
        <FadeIn data-id="element-118">
          <h2 className="text-4xl md:text-5xl text-center text-charcoal mb-16" data-id="element-119">
            Lo que obtienes hoy
          </h2>

          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-120">
            {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} className={`bg-white p-8 rounded-2xl shadow-warm border border-warmgray/10 flex flex-col items-center text-center ${index === 0 ? 'md:col-span-2 lg:col-span-3 bg-terracotta/5 border-terracotta/20' : ''}`} data-id="element-121">
                <div className="mb-4 p-3 bg-linen rounded-full" data-id="element-122">
                  {item.icon}
                </div>
                <h3 className="text-xl font-serif text-charcoal mb-2" data-id="element-123">
                  {item.title}
                </h3>
                <p className="text-warmgray" data-id="element-124">{item.desc}</p>
              </FadeIn>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}